import { Redirect, Route, RouteComponentProps, Switch } from "react-router-dom";
import { JSX, useContext } from "react";
import { NotFound } from "@app/shared/ErrorPages";
import Roles from "@app/user/roles";
import { UserContext } from "@app/user/UserContext";
import { Reports } from "@app/reports/Reports";
import AccuracyReportsWizard from "@app/reports/accuracy-reports/AccuracyReportsWizard";
import VolumeReportsWizard from "@app/reports/volume-reports/VolumeReportsWizard";

const ReportsRouter = (props: RouteComponentProps): JSX.Element => {
  const userContext = useContext(UserContext);
  
  return (
    <Switch>
      <Route path={`${props.match.path}`} exact={true} component={Reports} />
      <Route
        path={`${props.match.path}/create-volume-report/:reportType`}
        render={(props: RouteComponentProps) => (
          <VolumeReportsWizard {...props} />
        )}
      />
      <Route
        path={`${props.match.path}/create-accuracy-report/:reportType`}
        render={() => 
          userContext.roles.includes(Roles.ACCURACY_LICENSE_TIER_2) ? (
            <AccuracyReportsWizard />
          ) : (
            <NotFound />
          )
        }
      />
      <Redirect from={`${props.match.path}/create-volume-report`} exact={true} to={`${props.match.path}/`} />
      <Redirect from={`${props.match.path}/create-accuracy-report`} exact={true} to={`${props.match.path}/`} />
    </Switch >
  );
};

export default ReportsRouter;
